import { render, staticRenderFns } from "./AddManifest.vue?vue&type=template&id=53f6ef2b&scoped=true&"
import script from "./AddManifest.vue?vue&type=script&lang=js&"
export * from "./AddManifest.vue?vue&type=script&lang=js&"
import style0 from "./AddManifest.vue?vue&type=style&index=0&id=53f6ef2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f6ef2b",
  null
  
)

export default component.exports